/*
 * As linhas que brilham enquanto a lista de tópicos carrega (trocar de
 * categoria, de filtro ou de ordem), no lugar do spinner do core.
 *
 * Cada linha usa as mesmas classes da linha real (listItem.tsx): título,
 * badges, postadores, respostas, visualizações e atividade, no desktop em
 * colunas e no celular com o avatar de 48px e os números nos cantos. As
 * barras ficam dentro desses elementos (com a fonte e a altura de linha
 * deles) e caem onde o texto vai cair: nada pula quando a lista chega.
 */
import app from 'flarum/forum/app';
import { forumBool } from '../utils/settings';
const ROWS = 8;

/** Larguras que variam de linha para linha, para não parecer uma grade. */
const TITLES = [62, 44, 71, 38, 55, 66, 48, 59];
const BADGES = ['5em', '7em', '4.5em', '6em'];
function row(index, showViews) {
  return m("li", {
    key: `canela-skeleton-${index}`,
    className: "CanelaListSkeleton-item",
    "aria-hidden": "true"
  }, m("div", {
    className: "DiscussionListItem CanelaListSkeleton"
  }, m("div", {
    className: "DiscussionListItem-content"
  }, m("div", {
    className: "CanelaListItem-avatar"
  }, m("span", {
    className: "Avatar CanelaSkeleton"
  })), m("div", {
    className: "DiscussionListItem-main CanelaTopic"
  }, m("h2", {
    className: "DiscussionListItem-title CanelaTopic-titleLine"
  }, m("span", {
    className: "CanelaSkeleton CanelaSkeleton--line",
    style: {
      width: `${TITLES[index % TITLES.length]}%`
    }
  })), m("div", {
    className: "CanelaTopic-meta"
  }, m("span", {
    className: "CanelaSkeleton CanelaSkeleton--line",
    style: {
      width: BADGES[index % BADGES.length]
    }
  }))), forumBool('canelaListPosters', true) && m("div", {
    className: "CanelaCell CanelaCell--posters CanelaPosters"
  }, index % 3 ? m("span", {
    className: "CanelaPosters-avatar"
  }, m("span", {
    className: "Avatar CanelaSkeleton"
  })) : null, m("span", {
    className: "CanelaPosters-avatar CanelaPosters-avatar--latest"
  }, m("span", {
    className: "Avatar CanelaSkeleton"
  }))), m("div", {
    className: "CanelaCell CanelaCell--replies"
  }, m("span", {
    className: "CanelaSkeleton CanelaSkeleton--word CanelaListSkeleton-number"
  })), showViews && m("div", {
    className: "CanelaCell CanelaCell--views"
  }, m("span", {
    className: "CanelaSkeleton CanelaSkeleton--word CanelaListSkeleton-number"
  })), m("div", {
    className: "CanelaCell CanelaCell--activity"
  }, m("span", {
    className: "CanelaActivity"
  }, m("span", {
    className: "CanelaSkeleton CanelaSkeleton--word CanelaListSkeleton-age"
  })))), app.session.user ? m("div", {
    className: "DiscussionListItem-controls"
  }) : null));
}
export default function listSkeleton(showViews) {
  return Array.from({
    length: ROWS
  }, (_, index) => row(index, showViews));
}
flarum.reg.add('ramon-canela', 'forum/list/listSkeleton', listSkeleton);